import { memo } from 'react';
import type { SwitchProps } from '@mui/material/Switch';
import { MuiSwitch } from './styles';
import FormControlLabel from '@mui/material/FormControlLabel';
import { Loading } from '../../../loading';

interface CustomSwitchProps extends SwitchProps {
  label?: string;
  loading?: boolean;
}

export const Switch = memo(function Switch({
  sx = {},
  label,
  loading = false,
  ...props
}: CustomSwitchProps) {
  if (loading) {
    return (
      <div style={{ padding: '4px' }}>
        <Loading size={18} isGreen />
      </div>
    );
  }

  return (
    <FormControlLabel
      sx={{ m: 0 }}
      area-label={label}
      control={
        <MuiSwitch aria-label={label} sx={{ ...sx, mr: 1 }} {...props} />
      }
      label={label!}
    />
  );
});
